export function getLogoUrl(fileName?: string): string | undefined {
  if (!fileName) return undefined;

  const ext = fileName.split('.').pop();

  return ext ? `/static/branding/logo.${ext}` : undefined;
}
